<template>
  <section
    id="recent-projects"
    class="hide-overflow"
  >
    <v-layout>
      <v-flex
        xs12
        md6
        primary
        text-xs-center
        pa-5
        white--text
      >
        <base-bubble-1
          style="transform: rotate(180deg) translateX(25%)"
        />
        <base-text class="mb-3">
          {{ $t('teamProjects') }}
        </base-text>

        <v-card color="secondary">
          <v-container
            grid-list-md
            pa-2
          >
            <v-layout wrap>
              <v-flex
                v-for="project in projects.projects "
                :key="project.id"
                xs12
                md6
              >
                <base-text class="mb-1">
                  {{ project.name }}<br>
                </base-text>
                <a
                  :href="project.href"
                  target="_blank"
                >
                  <v-img
                    :src="project.src"
                    max-height="300"
                  />
                </a>
                <text-small class="mt-2 ">
                  {{ project.stack }}
                </text-small>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>

        <base-text class="mt-4">
          {{ $t('myProjects') }}
        </base-text>

        <v-card color="secondary">
          <v-container
            grid-list-md
            pa-2
          >
            <v-layout wrap>
              <v-flex
                v-for="project in projects.myProjects"
                :key="project.id"
                xs12
                md6
              >
                <base-text class="mb-3">
                  {{ project.name }}<br>
                </base-text>
                <a
                  :href="project.href"
                  target="_blank"
                >
                  <v-img
                    :src="project.src"
                    max-height="300"
                  />
                </a>
                <text-small class="mt-2">
                  {{ project.stack }}
                </text-small>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex
        hidden-sm-and-down
        md6
      >
        <v-img
          :src="'https://firebasestorage.googleapis.com/v0/b/testingsystemdls.appspot.com/o/freelance%2FDSC_4610_h_1000.jpg?alt=media&token=88fe0bf1-b299-41a6-8d33-427574c96dd3'"
          height="100%"
        />
      </v-flex>
    </v-layout>
  </section>
</template>

<script>
import project from '../locales/projects'
export default {
  computed: {
    projects () {
      switch (this.$store.getters.getLanguage) {
        case 'en': return project.en
        case 'ru': return project.ru
        case 'uk': return project.uk
        default: return project.en
      }
    }
  }
}
</script>
